<script>
import {VueTelInput} from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

export default {
  name: "InputPhone",
  components: {
    VueTelInput,
  },
  props: ["value", "isInvalid"],
  data() {
    return {
      phone: this.value,
      isValid: false,
      isError: !!this.isInvalid,
    };
  },
  methods: {
    onInput(value, objectValue) {
      if (this.checkIfInvalid(objectValue)) {
        this.$emit("input", value, objectValue);
      } else {
        this.$emit("input", null, objectValue);
      }
    },
    checkIfInvalid(phoneDetails) {
      if (phoneDetails?.valid) {
        this.isValid = true;
        this.isError = false;
      } else {
        this.isValid = false;
      }
      return this.isValid;
    },
  },
  computed: {
    phoneProps() {
      return {
        inputOptions: {
          autocomplete: "off",
          name: "phonenumber",
          placeholder: "+33 1 23 45 67 89",
          showDialCode: true,
        },
        defaultCountry: "fr",
        validCharactersOnly: true,
        ...this.$attrs,
      };
    },
  },
};
</script>

<template>
  <div class="w-100 position-relative">
    <VueTelInput
        class="InputPhone"
        :class="{ 'is-valid': isValid, 'is-error': isError || isInvalid }"
        v-model="phone"
        v-bind="phoneProps"
        @input="onInput"
        v-on="$listeners"
    >
      <template v-slot:arrow-icon>
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </template>
    </VueTelInput>
    <div v-show="isValid" class="validation-check text-success">
      <i class="fa fa-check fa-lg" aria-hidden="true"></i>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.InputPhone {
  border: var(--input-border);
  height: var(--input-height);
  padding: 0 0;
  border-radius: var(--input-radius);
  width: 100%;
  min-width: 0px;

  &:focus-within {
    border-color: var(--input-focus-border-color);
    box-shadow: var(--input-focus-shadow);
  }

  &.is-error {
    border-color: var(--input-error-border-color);
  }
}

.validation-check {
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
}
</style>
<style lang="scss">
.InputPhone {
  .vti__input {
    font-family: var(--fonts-code);
    border-radius: var(--input-radius);
    background: transparent;
  }

  .vti__dropdown {
    &:focus {
      background-color: var(--colors-gray-100);
      box-shadow: inset 0 0 0 2px var(--input-focus-border-color);
    }
  }

  .vti__dropdown-list.below {
    margin-top: 2px;
  }

  .vti__dropdown-list.above {
    margin-bottom: 2px;
  }

  .vti__dropdown-item > span {
    font-family: var(--fonts-code);
  }
}
</style>
